import type { QueryKey } from 'react-query';
import type { GetStripePaymentMethodIdProps } from '../requests/get-stripe-payment-method-id';

export const paymentMethodQueryKeys = {
  baseQuery: ['payments-payment-method'],
  getStripePaymentMethodIdBase: () => [...paymentMethodQueryKeys.baseQuery, 'stripe-payment-method-id'],
  getStripePaymentMethodId: (request: GetStripePaymentMethodIdProps): QueryKey => [
    ...paymentMethodQueryKeys.getStripePaymentMethodIdBase(),
    request.locationId,
    request.paymentUuid,
  ],
};
